import styled from 'styled-components';

export const DialogMessage = styled.div`
  padding: 0.5rem 1.5rem;
  line-height: 1.5;
  font-size: 1rem;
`;
